export default [
  {
    id: '0',
    name: '全部',
    desc: '全部',
    group: '全部',
  },

  // 数字政务能力
  {
    id: '1',
    name: 'API网关',
    desc: 'API网关',
    group: '数字政务能力',
    canNotApply: true,
  },
  {
    id: '2',
    name: '准入网关',
    desc: '准入网关',
    group: '数字政务能力',
    canNotApply: true,
  },
  // {
  //   id: '3',
  //   name: '容器服务',
  //   desc: '容器服务',
  //   group: '数字政务能力',
  //   canNotApply: true,
  // },
  {
    id: '4',
    name: '物流服务',
    desc: '物流服务',
    group: '数字政务能力',
  },
  {
    id: '5',
    name: '统一身份认证',
    desc: '统一身份认证',
    group: '数字政务能力',
  },
  {
    id: '6',
    name: '电子签章',
    desc: '电子签章',
    group: '数字政务能力',
  },
  {
    id: '7',
    name: '电子证照',
    desc: '电子证照',
    group: '数字政务能力',
  },
  {
    id: '8',
    name: '事项目录',
    desc: '事项目录',
    group: '数字政务能力',
  },

  // 腾讯云
  {
    id: '9',
    name: '腾讯位置服务',
    desc: '腾讯位置服务',
    group: '腾讯云',
    canNotApply: true,
  },
  {
    id: '18',
    name: '智能图像-人脸核身',
    desc: '智能图像-人脸核身',
    group: '腾讯云',
    canNotApply: true,
  },
  {
    id: '19',
    name: '智能图像-人脸识别',
    desc: '智能图像-人脸识别',
    group: '腾讯云',
    canNotApply: true,
  },
  {
    id: '20',
    name: '智能图像-文字识别',
    desc: '智能图像-文字识别',
    group: '腾讯云',
    canNotApply: true,
  },
  {
    id: '11',
    name: '实时音视频',
    desc: '实时音视频',
    group: '腾讯云',
    canNotApply: true,
  },

  // 微信能力
  {
    id: '12',
    name: '人脸核身',
    desc: '人脸核身',
    group: '微信能力',
  },
  {
    id: '13',
    name: '微信支付实名认证',
    desc: '微信支付实名认证',
    group: '微信能力',
  },
  {
    id: '14',
    name: '非税支付',
    desc: '非税支付',
    group: '微信能力',
    canNotApply: true,
  },

  // 政务微信能力
  {
    id: '15',
    name: '统一登录',
    desc: '统一登录',
    group: '政务微信能力',
  },
  {
    id: '16',
    name: '通讯录管理',
    desc: '通讯录管理',
    group: '政务微信能力',
  },
  {
    id: '17',
    name: '应用管理',
    desc: '应用管理',
    group: '政务微信能力',
  },
];
